<template>
  <div>
    <ConsentsEdit></ConsentsEdit>
  </div>
</template>

<script>
import ConsentsEdit from "@/components/profile/manage/ConsentsEdit";
export default {
    name: "ConsentsView",
    components: { ConsentsEdit },
};
</script>

<style>
[data-view-type="profile"] .bb-view-background {
	background: var(--profile-background);
}
</style>
